import {combineReducers} from '@reduxjs/toolkit';

import {accountEntitlementsStateSlice} from './slices/account-entitlements-state.slice';
import {accountEntitlementsSlice} from './slices/account-entitlements.slice';

export const accountEntitlementsAssignedReducer = combineReducers({
    entitlements: accountEntitlementsSlice.reducer,
    state: accountEntitlementsStateSlice.reducer,
});
